import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/telephone.svg")